import React from 'react';
import '../../styles/services.css';
import { motion } from 'framer-motion';

const CustomSoftware = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>Custom Software Development</h1>
      <p>We build enterprise-grade software tailored to your needs. From architecture to deployment — fast, scalable, secure.</p>
      <ul className="bullet-points">
        <li>🧩 End-to-end product development</li>
        <li>🧪 Agile & test-driven delivery</li>
        <li>⚙️ Scalable microservices & APIs</li>
        <li>🛡️ Security-first architecture</li>
      </ul>
    </div>
  </motion.div>
);

export default CustomSoftware;
